import { saleStatusHistory } from '@/config'

const detail = {
  line1: [
    {
      name: 'registerDate',
      text: 'storage.storage_register-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'shipDate',
      text: 'ship.ship_ship-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'arrivedDay',
      text: 'ship.ship_arrival-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'status',
      text: 'common.common_status',
      component: 'SelectStatusStockMove',
      cols: 4
    }
  ],
  line2: [
    {
      name: 'storage',
      text: 'ship.ship_ship-storage',
      component: 'SearchShipAndLoadingStorage'
    },
    {
      name: 'stockMoveInfo',
      text: 'storage.storage_storage-move-info',
      placeholder: 'storage.storage_storage-move-number'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    }
  ]
}

export default { detail }
